import { render, staticRenderFns } from "./yeji-dialog.vue?vue&type=template&id=637d540e&"
import script from "./yeji-dialog.vue?vue&type=script&lang=js&"
export * from "./yeji-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "yeji-dialog.vue"
export default component.exports